import { Link } from 'react-router-dom';

export default function CTASplit() {
  return (
    <section className="w-full">
      <div className="flex flex-col lg:flex-row">
        {/* Left - Image side */}
        <div className="lg:w-1/2 relative h-[350px] md:h-[500px] lg:h-[600px] overflow-hidden bg-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=Young%20shopper%20carrying%20multiple%20brown%20paper%20shopping%20bags%20walking%20on%20sunny%20tree%20lined%20avenue%20in%20European%20city%2C%20joyful%20retail%20therapy%20moment%2C%20golden%20afternoon%20sunlight%20filtering%20through%20leaves%2C%20fashionable%20casual%20outfit%2C%20lifestyle%20street%20photography%2C%20carefree%20upscale%20shopping%20experience&width=1200&height=1600&seq=cta-split-v2&orientation=portrait"
            alt="CSSBuy Spreadsheet shopping lifestyle"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-50/30"></div>
          <div className="absolute bottom-8 left-8 md:bottom-12 md:left-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/90 text-foreground-700 text-xs font-semibold">
              Featured Products
            </span>
            <h3 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mt-4 leading-tight drop-shadow-lg">
              Discover Your
              <br />
              Next Find
            </h3>
          </div>
        </div>

        {/* Right - CTA side */}
        <div className="lg:w-1/2 flex items-center justify-center py-14 md:py-20 px-6 md:px-12 lg:px-16 bg-background-50">
          <div className="max-w-md text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Ready to
              <br />
              Start Shopping?
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
              Access over 1000+ verified spreadsheet listings across 14 product categories. From sneakers and hoodies to bags and accessories — everything you need is one click away on CSSBuy Sheet.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <Link
                to="/article/cssbuy-spreadsheet-complete-guide"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-100 text-foreground-700 font-semibold text-sm hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Read Our Guide
              </Link>
            </div>

            {/* Trust marks */}
            <div className="mt-8 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-checkbox-circle-fill text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span>100% Free Access</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-checkbox-circle-fill text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span>No Registration Required</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-checkbox-circle-fill text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span>Updated Daily</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}